import Vue from 'vue';
import messageModal from '@/components/modal/messageModal.vue';
import confirmModal from '@/components//modal/confirmModal.vue';
import otpModal from '@/components/modal/otpModal.vue';
import optionModal from '@/components/modal/selectOptionModal.vue';
import sortModal from '@/components/modal/sortModal.vue';
import guestModal from '@/components/modal/guestModal';
import filterModal from '@/components/modal/filterModal';
import datepickerModal from '@/components/modal/datepickerModal';

Vue.component('messageModal', messageModal);
Vue.component('confirmModal', confirmModal);
Vue.component('otpModal', otpModal);
Vue.component('optionModal', optionModal);
Vue.component('sortModal', sortModal);
Vue.component('guestModal', guestModal);
Vue.component('filterModal', filterModal);
Vue.component('datepickerModal', datepickerModal);
